import { getPackMonthNumFromTextMode } from 'utils/mappers';
import { convertLocaleMobileNumToNumWithDialCode } from 'utils';
import { convertDateToTwoDigitsFormat } from 'utils/date';
export const createBillsObject = (apiObject) => {
  return (
    apiObject.invoices &&
    apiObject.invoices.map((invoice) => {
      const accountType = invoice.meta.packType;
      return {
        name: invoice.name,
        number: invoice.number,
        date: invoice.createdAt,
        accountType,
        chargeCount: invoice.meta.chargeCount ? invoice.meta.chargeCount : 0,
        price: invoice.meta.totalAfterOff ? invoice.meta.totalAfterOff : 0,
        status: invoice.status === '1' ? 'paid' : 'unpaid',
        isPackageUpgrade: invoice.isOrderPack,
        paymentGateway: invoice.paymentGateway,
        paymentMethod: invoice.paymentMethod === 'online' ? 'آنلاين' : 'آفلاين',
        isOfficialBillNeeded: invoice.officialEnabled,
        duration: invoice.meta.month,
        transactionCode: invoice.meta.refId,
        uniqueId: invoice.uniqueId,
        totalRawPrice: invoice.meta.total,
        totalTax: invoice.meta.totalTax,
        postPrice: invoice.meta.postPrice,
        totalOff: invoice.meta.totalOff,
        official: invoice.meta?.official
          ? createPaymentInfoObject(invoice.meta.official)
          : {},
        // for invoices that are for conversation purchase it will return one conversation price otherwise it will  be undefined
        conversationPrice: !invoice.isOrderPack && invoice.meta.price,

        isPackagePurchase: +invoice.type === 1,
      };
    })
  );
};

export const createEngBillsObject = (data) =>
  data.map((item) => ({
    name: `${item.payer.first_name} ${item.payer.last_name}`,
    number: item.number,
    date: item.createdAt,
    accountType: item.package.type,
    chargeCount: item.type === 2 ? item.price.payable : 0,
    price: item.price.payable,
    status: item.status === 1 ? 'paid' : 'unpaid',
    paymentGateway: item.paymentGateway,
    paymentMethod: 'online',
    totalRawPrice: item.package.payable,
    isPackagePurchase: +item.type === 1,
    totalOff: item.offer.amount,
    duration: item.package.month,
    uniqueId: item.paymentId,
  }));

export const createPaymentInfoObject = (apiObject) => {
  const formType = typeof apiObject.country === 'object' ? 'en' : 'fa';

  const adaptedObject = { formType };

  if (apiObject.type === 1) {
    adaptedObject.selectedForm = 'company';
    adaptedObject.companyName = apiObject.name || apiObject.coName;
    adaptedObject.nationalNumber =
      apiObject.economicId || apiObject.nationalId || apiObject.melliNum;
    adaptedObject.economicCode = apiObject.economicCode || apiObject.eqNum;
    adaptedObject.registerNumber =
      apiObject.registrationNumber || apiObject.sabtNum;
    adaptedObject.phone = apiObject.tel || apiObject.phone;
    adaptedObject.mobile = convertLocaleMobileNumToNumWithDialCode(
      apiObject.mobile || apiObject.mobilePhone
    );

    adaptedObject.province = apiObject.state;
    adaptedObject.city = apiObject.city;
    adaptedObject.postalCode = apiObject.postCode || apiObject.postalCode;
    adaptedObject.address = apiObject.address;
    adaptedObject.country = apiObject.country || 'ایران';
  } else if (apiObject.type === 2) {
    adaptedObject.selectedForm = 'person';
    adaptedObject.name = apiObject.firstName || apiObject.name;
    adaptedObject.family = apiObject.lastName || apiObject.family;

    adaptedObject.id = apiObject.nationalId;

    adaptedObject.mobileNumber = convertLocaleMobileNumToNumWithDialCode(
      apiObject.mobile || apiObject.mobilePhone
    );
    adaptedObject.phoneNumber = apiObject.tel || apiObject.phone;
    adaptedObject.residenceProvince = apiObject.state;
    adaptedObject.residenceCity = apiObject.city;
    adaptedObject.residencePostalCode =
      apiObject.postCode || apiObject.postalCode;
    adaptedObject.residenceAddress = apiObject.address;
    adaptedObject.residenceCountry = apiObject.country || 'ایران';
    adaptedObject.birthDate = !isNaN(Date.parse(apiObject.birthDate))
      ? apiObject.birthDate
      : '';
  } else if (!apiObject.type && apiObject.coName) {
    adaptedObject.selectedForm = 'company';
    adaptedObject.companyName = apiObject.coName;
    adaptedObject.nationalNumber = apiObject.melliNum;
    adaptedObject.economicCode = apiObject.eqNum;
    adaptedObject.registerNumber = apiObject.sabtNum;
    adaptedObject.phone = apiObject.phone;
    adaptedObject.mobile = convertLocaleMobileNumToNumWithDialCode(
      apiObject.mobilePhone
    );

    adaptedObject.postalCode = apiObject.postalCode;
    adaptedObject.address = apiObject.address;
    adaptedObject.country = 'ایران';
  }

  return adaptedObject;
};

// returns array of user info based on 'haghighi', 'hoghoghi'
export const getArrayOfInfoBasedOnUserType = (infoData) => {
  if (infoData?.selectedForm === 'person') {
    return [
      {
        label: 'نام',
        value: infoData.name,
        id: 'name',
      },
      {
        label: 'نام خانوادگی',
        value: infoData.family,
        id: 'family',
      },
      { label: 'کدملی', value: infoData.id, id: 'id' },
      // {
      //   label: 'کشور',
      //   value: infoData.residenceCountry,
      //   id: 'residenceCountry',
      // },
      { label: 'شهر', value: infoData.residenceCity, id: 'residenceCity' },
      {
        id: 'residenceProvince',
        label: 'استان',
        value: infoData.residenceProvince,
      },
      {
        label: 'شماره موبایل',
        value: infoData.mobileNumber,
        id: 'mobileNumber',
      },
      {
        id: 'residencePostalCode',
        label: 'کدپستی',
        value: infoData.residencePostalCode,
      },
      {
        id: 'residenceAddress',
        label: 'آدرس',
        value: infoData.residenceAddress,
      },
    ];
  }

  if (infoData?.selectedForm === 'company') {
    return [
      { label: 'موبایل', value: infoData.mobile, id: 'mobile' },
      {
        label: 'شناسه ملی',
        value: infoData.nationalNumber,
        id: 'nationalNumber',
      },
      { label: 'تلفن دفتر', value: infoData.phone, id: 'phone' },
      { label: 'نام شرکت', value: infoData.companyName, id: 'companyName' },
      { label: 'آدرس', value: infoData.address, id: 'address' },
      { label: 'شهر', value: infoData.city, id: 'city' },
      { label: 'استان', value: infoData.province, id: 'province' },
      // { label: 'کشور', value: infoData.country, id: 'country' },
      { label: 'کدپستی', value: infoData.postalCode, id: 'postalCode' },
      // conditional because phone field is not mandatory
      // infoData.phone && { label: 'تلفن', value: infoData.phone },
    ];
  }
};

const packagesStatics = {
  features_fa: {
    professional: [
      'به ازای هر ماه ۵۰۰ شارژ مکالمه اولیه',
      'آرشیو ۳۰ روز مکالمات',
      'مدیریت ۱ وب سایت',
      'مکالمه بین اپراتورها',
      'انتقال گفتگو مابین اپراتورها',
      'تعداد اپراتور نامحدود',
      'امکان آپلود فایل تا ۱۰ مگابایت',
      'پیام ها جهت پشتیبانی تا ۷۲ ساعت پاسخ داده می شوند .',
      'پشتیبانی فنی شامل هزینه جداگانه می باشد .',
      'این پکیج شامل پشتیبانی تلفنی نمی شود .',
    ],
    commerical: [
      '۱۰۰۰ مکالمه‌ی جدید',
      'آمار حرفه‌ای اپراتور‌ها',
      'خروجی اکسل از اطلاعات کاربران',
      'ارسال ۶ پیام‌ هوشمند',
      'اختصاص اپراتور به لینک',
      'امکان آپلود فایل تا ۲۰ مگابایت',
      'امکان استفاده از API',
      'پاسخ‌های آماده',
      'اتصال به تلگرام',
      'ارسال ویس در ابزارک',
      'افزودن کاربر به لیست اسپم',
      'امکان حذف متن "قدرت گرفته از رایچت " در ابزارک',
      'شخصی سازی فرم‌ها',
      'مدیریت ۵ وب سایت',

      // '1000 شارژ مکالمه اولیه',
      // 'آمار حرفه ای اپراتور ها',
      // 'ارسال ۶ پیام هوشمند',
      // 'حجم ارسال فایل ۲۰ مگابایت',
      // 'آرشیو مکالمات ۱۸۰ روز',
      // 'خروجی csv از اطلاعات کاربران و لید های جمع شده',
      // 'ارسال وویس ابزارک',
      // 'تعریف زمان های کاری و غیر کاری',
    ],

    growth: [
      '۱۰۰۰ مکالمه‌ی جدید',
      'آمار حرفه‌ای اپراتور‌ها',
      'خروجی اکسل از اطلاعات کاربران',
      'ارسال ۶ پیام‌ هوشمند',
      'اختصاص اپراتور به لینک',
      'امکان آپلود فایل تا ۲۰ مگابایت',
      'امکان استفاده از API',
      'پاسخ‌های آماده',
      'اتصال به تلگرام',
      'ارسال ویس در ابزارک',
      'افزودن کاربر به لیست اسپم',
      'امکان حذف متن "قدرت گرفته از رایچت " در ابزارک',
      'شخصی سازی فرم‌ها',
      'مدیریت ۵ وب سایت',
    ],

    premium: [
      'مکالمه جدید نامحدود',
      // 'وب سایت جدید نامحدود',
      'مدیریت وب سایت تا ۱۵',
      'تعداد بازدید همزمان نامحدود',
      'ارسال پیام‌های هوشمند نامحدود',
      'ربات پاسخگویی',
      'حالت انتظار',
      'نقشه‌ی راه',
      'مانیتوریتگ لحظه‌ای بازدید کنندگان',
      'امکان آپلود فایل تا ۳۰ مگابایت',
      'خروجی اکسل + آمار حرفه‌ای اپراتورها',
      'شخصی سازی لوگوی سازما‌‌نی در ابزارک',
      'اتصال مستقیم با واتس‌اپ (پاسخگویی واتس‌اپ از رایچت)',
      'ارسال ایمیل به کاربران',
      'اکسپورت متن چت ها',
      'آمار رضایت مشتری',
      'پیام گروهی',
      'تیم و دپارتمان بندی',
      'وب هوک برای کاربران و چت‌ها',
      'پشتیبانی اختصاصی',

      // 'ربات پاسخ گویی ۷ مرحله',
      // 'فیچر واتساپ برای 1 سایت',
      // 'شارژ نامحدود مکالمه',
      // 'مانیتورینگ لحظه‌ای بازدیدکنندگان',
      // 'پاسخ های آماده',
      // 'وب هوک',
      // 'API سمت کاربر',
      // 'آمار حرفه ای اپراتور ها و خروجی csv',
      // 'افزودن کاربر به لیست اسپم',
      // 'ارسال نامحدود پیام هوشمند',
      // 'شخصی سازی لوگو ابزارک',
      // 'مدیریت نامحدود وب سایت',
      // 'حجم ارسال فایل ۳۰ مگابایت',
    ],
    premiumPlus: [
      'تغییرات فیچر ها',
      'چت بات هوش مصنوعی',
      'تعداد سایت نامحدود',
      'ربات پاسخ گویی پریمیوم ۱۵ مرحله',
      'فیچر واتساپ برای ۱۰ سایت',
      'حجم ارسال فایل ۱۰۰ مگابایت',
      'آرشیو مکالمات ۵ سال',
      'امنیت و کد گذاری داده های پیشرفته',
      'پشتیبانی ۲۴*۷',
    ],
    vip: [
      'دستیار هوش مصنوعی ۵۰۰۰۰ دیالوگ در ماه',
      'مدیریت تعداد نامحدود وبسایت',
      'مدیریت و ایجاد ۴۰۰۰ صفحه پایگاه دانش',
      'اتصال به واتس‌اپ و تلگرام',
      'پشتیبانی اختصاصی 24/7',
    ],
  },
  features_en: {
    professional: [
      '500 initial call charge per month',
      'Send smart messages',
      'Archive of 180 days of conversations',
      'Management of 1 websites',
      'conversation between operators',
      'Transferring conversations between operators',
      'Setting working hours',
      'Messages will be answered within 72 hours',
      'Technical support is included in the cost',
      'This package does not include phone support',
    ],
    commerical: [
      '1000 new conversations',
      'Professional statistics of operators',
      'csv export of user information',
      'Send 6 smart messages',
      'Upload files up to 30 MB',
      'Assign operator to URL',
      'Webhook for users and chats',
      'Ability to use API',
      'Ready answers',
      'Send voice in the widget',
      'Add user to spam list',
      'Ability to remove the text "Powered by raychat" in the widget',
      'Support',
      'Form customization',
    ],
    premium: [
      'Unlimited new conversation',
      'Unlimited new website',
      'Unlimited simultaneous visits',
      'Unlimited smart messages',
      'Responsive Bot',
      'Waiting mode',
      'Roadmap',
      'Chats export',
      'Connect to WhatsApp (Reply to users via WhatsApp)',
      'Professional statistics of operators + csv export',
      'Customizing widget logo',
      'Monitoring visitors',
      'Support',
    ],
    premiumPlus: [],
  },
};

const getPackageDescription = (previousPackageName, currentPackageType) => {
  if (currentPackageType === 'professional') return '';

  return {
    fa: `تمامی امکانات پکیج ${previousPackageName.fa} +  `,
    en: `All features of ${previousPackageName.en} package +  `,
  };
};

// gets duration months and item and returns dollar and tooman prices
const getPackagePricesPerMonth = (item, duration) => ({
  fa: item.price[duration] / 10,
  en: item.priceDollar[duration] || 0,
});

export const createPackagesObject = (apiObject) => {
  let adaptedObject = {
    // professional: {},
    // commerical: {}, replaced with growth
    growth: {},
    premium: {},
    premiumPlus: {},
    vip: {},
  };

  let enablesPackages = apiObject.packageEnabled;

  apiObject.packages.forEach((item, index) => {
    if (
      (item.type === 'professional' ||
        item.type === 'commerical' ||
        item.type === 'growth' ||
        item.type === 'vip' ||
        item.type === 'premium' ||
        item.type === 'premiumPlus') &&
      enablesPackages.includes(item.index)
    ) {
      adaptedObject[item.type] = {
        packageType: item.index,
        name: {
          fa: item.typeFa,
          en: item.type,
        },
        features: {
          fa: packagesStatics.features_fa[item.type],
          en: packagesStatics.features_en[item.type],
        },
        monthlyPrice: getPackagePricesPerMonth(item, '1'),
        quarterlyPrice: getPackagePricesPerMonth(item, '3'),
        yearlyPrice: getPackagePricesPerMonth(item, '12'),
        triennialPrice: getPackagePricesPerMonth(item, '36'),
        description: getPackageDescription(
          {
            fa:
              item.type === 'premiumPlus'
                ? apiObject.packages[2]?.typeFa
                : apiObject.packages[index - 1]?.typeFa,
            en:
              item.type === 'premiumPlus'
                ? apiObject.packages[2]?.type
                : apiObject.packages[index - 1]?.type,
          },
          item.type
        ),
        // it may be unlimited or a number representing valid days that user can get its conversations archive
        convsArchiveRange: item.conversationArchive,
      };
    }
  });
  return adaptedObject;
};

export const createPackageTypesObject = (packageTypes) => {
  let adaptedPackageTypes = {};
  for (let key in packageTypes) {
    adaptedPackageTypes[packageTypes[key].index] = {};

    adaptedPackageTypes[packageTypes[key].index]['fa'] =
      packageTypes[key].typeFa;
    adaptedPackageTypes[packageTypes[key].index]['en'] = packageTypes[key].type;
  }

  return adaptedPackageTypes;
};

export const createUseWhatsappPackages = (packageTypes) => {
  let adaptedPackageTypes = {};

  for (let key in packageTypes) {
    adaptedPackageTypes[packageTypes[key].index] = packageTypes[key].whatsapp;
  }

  return adaptedPackageTypes;
};

/* 
type: 1 => package purchase 
type: 2 => charge purchase */
export const getApiReadyDataForEngInvoice = (data) => {
  // package upgrade operation
  if (data.isPackageUpgrade) {
    return {
      type: 1,
      packType: data.selectedPackageType,
      packMonth: getPackMonthNumFromTextMode(data.selectedDuration),
      useCredit: data.useCredit,
      offerCode: data.discountCode || undefined,
    };
  }

  // conversation charge
  return {
    type: 2,
    chargeCount: data.selectedConversationCount,
  };
};

// TODO:  english version
// get text for saving info error
export const getInfoSpecialErrorMessage = (error) => {
  const ERROR_MESSAGES = {
    'phone or national id invalid error':
      'شماره تلفن و کدملی با هم همخوانی ندارند',
    'postal code invalid error': 'کدپستی معتبر نمیباشد',
    'national id or birth date invalid error':
      'تاریخ تولد با کدملی همخوانی ندارد',
    'server error': 'مشکلی از سمت سرور وجود دارد',
    'company invalid error': 'شناسه ملی شرکت صحیح نمیباشد',
  };

  if (error.response?.status === 400) {
    const errorMessage = error.response.data?.data.messages?.[0];

    return ERROR_MESSAGES[errorMessage];
  }
};

/**
 *
 * This function returns payload data for user info (haghighi - hoghoghi) API
 */
export const getPayloadDataForUserInfoApi = (data) => {
  const payloadData = {};

  if (data.selectedForm === 'company') {
    payloadData.type = 1;
    payloadData.tel = data.phone;
    payloadData.economicCode = data.nationalNumber;
    payloadData.name = data.companyName;
    payloadData.address = data.address;
    payloadData.city = data.city;
    payloadData.state = data.province;
    payloadData.postCode = data.postalCode;
  } else {
    payloadData.type = 2;
    payloadData.nationalId = data.id;
    payloadData.postCode = data.residencePostalCode;
    payloadData.birthDate = convertDateToTwoDigitsFormat(data.birthDate);
    payloadData.lastName = data.family;
    payloadData.firstName = data.name;
    payloadData.address = data.residenceAddress;
    payloadData.state = data.residenceProvince;
    payloadData.city = data.residenceCity;
  }

  return payloadData;
};

export const getCheckOfficialCustomError = (err = '') => {
  switch (err) {
    case 'user is invalid':
      return 'کد ملی با تاریخ تولد همخوانی ندارد';

    case 'post is invalid':
      return 'کدپستی وارد شده اشتباه است';

    case 'shahkar is invalid':
      return 'کدملی با شماره تلفن همخوانی ندارد';

    default:
      return '';
  }
};
